import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'Upload was cancelled or aborted by the user',
  name: 'upload_aborted',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'Time from queue creation to abort in milliseconds',
      name: 'upload_duration_ms',
      required: false,
      type: 'number',
    },
    {
      description: 'Upload lifecycle stage that was in progress when aborted',
      name: 'failed_stage',
      required: true,
      type: 'enum',
      values: ['create_upload', 'small_upload', 'part_upload', 'complete_upload', 'unknown'],
    },
  ],
};

export default META;
